import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

const ChooserItem = ({ children, content = {}, ...props }) => {
  const img = <img src={`/images/chooser/${content["foreground-image"]}`} alt={content.name} />;

  return (
    <div className={`item ${content.name}`}>
      {!content.url.match(/http(s?):\/\//) ? <Link to={content.url}>{img}</Link> : <a href={content.url}>{img}</a>}
      <div className="background" style={{"backgroundImage": `url(/images/chooser/${content["background-image"]})`, "backgroundPosition": content["background-position"]}}></div>
    </div>
  );
};

ChooserItem.propTypes = {
  content: PropTypes.object.isRequired,
};

export default ChooserItem;



// WEBPACK FOOTER //
// ./src/components/chooser/ChooserItem.js